//Import required modules
import { v4 } from 'uuid'

import { colorFuncAll  } from './colorData';
import titleColor from './titleColor.json'

import { makeColorArray } from './utilFunc'

const radius = 20;
const radiusSelected = 28;
const circleCount = 10;
const theme = 'dark';
const chartSelected = 'pie';

const darkIcon = 'fa fa-moon-o'
const lightIcon = 'fa fa-sun-o'
const darkColor = '#F7F7F7'
const lightColor = '#212121'
const dark= '#212121'
const light = '#F8F8F8'

const docWidth = 1200;
const docHeight = 500;
const rowHeight = 80;
const rowWidth = 600;
const maxHeight = 465;
const fontSize = 12;
const colorSpace = 0.8;
const textSpace = 1-colorSpace;

const vizHolderWidth = 200;


const userWindow = {docWidth,
    docHeight,
    rowHeight,
    rowWidth,
    maxHeight,
    vizHolderWidth,
    circleCount,
    radius,
    radiusSelected,
    fontSize,
    colorSpace,
    textSpace,
    removeX: 0.25*rowWidth,
    selectX: 0.75*rowWidth,
    removeY: colorSpace*rowHeight + ((textSpace*rowHeight)/2),
    selectY: colorSpace*rowHeight + ((textSpace*rowHeight)/2),
    darkColor,
    lightColor,
    darkIcon,
    lightIcon,  
    titleColor,
    colorCopied: 'rgb(0,0,0)',
    downloadsCsv: 0,
    downloadsJson: 0,
    downloadsJpeg: 0,
}

const colorFuncAllUpd = colorFuncAll.map((d) => ({colorFuncId: v4(), 
                                                    colorFuncName: d,
                                                    removeX: 0.25*rowWidth,
                                                    selectX: 0.75*rowWidth,
                                                    removeY: colorSpace*rowHeight + ((textSpace*rowHeight)/2),
                                                    selectY: colorSpace*rowHeight + ((textSpace*rowHeight)/2),
                                                    fontSize}))
const colorArr = colorFuncAllUpd.map((d) => makeColorArray(d, userWindow))


const stateData = {
    colorArr: colorArr,
    userPalette: [],
    theme: theme,
    simDisplay: false,
    chartSelected: chartSelected,
    userWindow: userWindow,
}


export { stateData }
